import { RemoteLoadCurrentAccount } from '@/javascript/data/usecases'
import { LoadCurrentAccount } from '@/javascript/domain/usecases'
import { makeApiUrl, makeAxiosHttpClient } from '../http'

declare var _currentAccount: { id: number }

export const makeRemoteLoadCurrentAccount = (): LoadCurrentAccount =>
  new RemoteLoadCurrentAccount(makeApiUrl(`/accounts/${_currentAccount.id}`), makeAxiosHttpClient())
